import InheritanceField from './InheritanceField';

export default InheritanceField;
